import RecommendedProductHeader from './recommended-product-header';

export default RecommendedProductHeader;
